import clsx from 'clsx'
import ProductVariantDropdown from 'snippets/product/product-variant/product-variant-dropdown'
import ProductVariantList from 'snippets/product/product-variant/product-variant-list'

const selectors = {
  COLOUR_KEYS: ['Colours', 'Colors'],
  DROPDOWN_TYPE: 'dropdown'
}

function ProductVariantGroup ({
  type,
  name,
  values,
  selected,
  setSelected,
  selectableValues,
  giftCard = false,
  isModalLayout = false
}) {
  return (
    <div className={clsx(!isModalLayout && 'mt-6', selectors.COLOUR_KEYS.includes(name) ? 'order-first' : '')}>
      {type === selectors.DROPDOWN_TYPE
        ? (
          <ProductVariantDropdown
            option={name}
            items={values}
            selected={selected}
            setSelected={setSelected}
            giftCard={giftCard}
            isModalLayout={isModalLayout}
          />
          )
        : (
          <ProductVariantList
            option={name}
            items={values}
            selected={selected}
            setSelected={setSelected}
            selectableValues={selectableValues}
          />
          )}
    </div>
  )
}

export default ProductVariantGroup
